const admy = {
  // ── SeoPage ──
  "admy.seo_keywords_ph": "Parola chiave1, Parola chiave2, Parola chiave3",

  // ── SocialPage placeholders ──
  "admy.eg_followers": "es. 12.4k",
  "admy.eg_posts": "es. 238",
  "admy.eg_likes": "es. 48.6k",
  "admy.eg_shortcode": "es. CxG7kPqLmN3",

  // ── TranslationsPage group names ──
  "admy.grp_nav": "Navigazione",
  "admy.grp_hero": "Home Hero",
  "admy.grp_services": "Servizi",
  "admy.grp_about": "Chi siamo",
  "admy.grp_pricing": "Prezzi",
  "admy.grp_booking": "Prenotazione",
  "admy.grp_footer": "Footer",
  "admy.grp_gallery": "Galleria",
  "admy.grp_team": "Team",
  "admy.grp_clinic": "Clinica",
  "admy.grp_process": "Processo",
  "admy.grp_trust": "Fiducia",
  "admy.grp_dental": "Odontoiatria",
  "admy.grp_overview": "Panoramica",
  "admy.grp_implants": "Impianti",
  "admy.grp_contact": "Contatto",
  "admy.grp_seo": "SEO",
  "admy.grp_admin": "Admin",
  "admy.grp_privacy": "Privacy",
  "admy.grp_imprint": "Note legali",
  "admy.grp_agb": "Termini",
  "admy.grp_language": "Lingue",
  "admy.grp_service_detail": "Dettaglio servizio",
  "admy.grp_instagram": "Instagram",

  // ── PageEditorPage field labels (home) ──
  "admy.f_hero_line1": "Hero — Riga 1",
  "admy.f_hero_line2": "Hero — Riga 2",
  "admy.f_hero_subtitle": "Hero — Sottotitolo",
  "admy.f_hero_cta": "Hero — Pulsante CTA",
  "admy.f_services_tag": "Servizi — Etichetta",
  "admy.f_services_heading": "Servizi — Titolo",
  "admy.f_services_subtitle": "Servizi — Sottotitolo",
  "admy.f_hair_title": "Trapianto di capelli — Titolo",
  "admy.f_hair_desc": "Trapianto di capelli — Descrizione",
  "admy.f_dental_title": "Estetica dentale — Titolo",
  "admy.f_dental_desc": "Estetica dentale — Descrizione",
  "admy.f_botox_title": "Botox & filler — Titolo",
  "admy.f_botox_desc": "Botox & filler — Descrizione",
  "admy.f_services_cta": "Servizi — Testo CTA",
  "admy.f_about_tag": "Chi siamo — Etichetta",
  "admy.f_about_line1": "Chi siamo — Riga 1",
  "admy.f_about_line2": "Chi siamo — Riga 2",
  "admy.f_about_desc": "Chi siamo — Descrizione",
  "admy.f_about_cta": "Chi siamo — CTA",
  "admy.f_pricing_tag": "Prezzi — Etichetta",
  "admy.f_pricing_line1": "Prezzi — Riga 1",
  "admy.f_pricing_line2": "Prezzi — Riga 2",
  "admy.f_pricing_subtitle": "Prezzi — Sottotitolo",
  "admy.f_pricing_cta": "Prezzi — CTA",
  "admy.f_testimonials_tag": "Recensioni — Etichetta",
  "admy.f_testimonials_heading": "Recensioni — Titolo",
  "admy.f_testimonials_subtitle": "Recensioni — Sottotitolo",
  "admy.f_testimonial1_text": "Recensione 1 — Testo",
  "admy.f_testimonial1_name": "Recensione 1 — Nome",
  "admy.f_testimonial1_role": "Recensione 1 — Ruolo",
  "admy.f_testimonial2_text": "Recensione 2 — Testo",
  "admy.f_testimonial2_name": "Recensione 2 — Nome",
  "admy.f_testimonial2_role": "Recensione 2 — Ruolo",
  "admy.f_testimonial3_text": "Recensione 3 — Testo",
  "admy.f_testimonial3_name": "Recensione 3 — Nome",
  "admy.f_testimonial3_role": "Recensione 3 — Ruolo",
  "admy.f_testimonial4_text": "Recensione 4 — Testo",
  "admy.f_testimonial4_name": "Recensione 4 — Nome",
  "admy.f_testimonial4_role": "Recensione 4 — Ruolo",
  "admy.f_testimonial5_text": "Recensione 5 — Testo",
  "admy.f_testimonial5_name": "Recensione 5 — Nome",
  "admy.f_testimonial5_role": "Recensione 5 — Ruolo",
  "admy.f_booking_tag": "Prenotazione — Etichetta",
  "admy.f_booking_line1": "Prenotazione — Riga 1",
  "admy.f_booking_line2": "Prenotazione — Riga 2",
  "admy.f_booking_desc": "Prenotazione — Descrizione",
  "admy.f_booking_cta": "Prenotazione — CTA",
  "admy.f_process_tag": "Processo — Etichetta",
  "admy.f_process_heading": "Processo — Titolo",
  "admy.f_process_subtitle": "Processo — Sottotitolo",
  "admy.f_trust_tag": "Fiducia — Etichetta",
  "admy.f_trust_heading": "Fiducia — Titolo",
  "admy.f_trust_subtitle": "Fiducia — Sottotitolo",
  "admy.f_instagram_heading": "Instagram — Titolo",
  "admy.f_instagram_cta": "Instagram — CTA",
  "admy.f_footer_company": "Footer — Nome azienda",
  "admy.f_footer_address": "Footer — Indirizzo",
  "admy.f_footer_phone": "Footer — Telefono",
  "admy.f_footer_email": "Footer — E-mail",
  "admy.f_img_hero_bg": "Immagine — Sfondo Hero",
  "admy.f_img_hair": "Immagine — Trapianto di capelli",
  "admy.f_img_dental": "Immagine — Estetica dentale",
  "admy.f_img_botox": "Immagine — Botox & filler",
  "admy.f_img_about_team": "Immagine — Team Chi siamo",
  "admy.f_img_cta_bg": "Immagine — Sfondo CTA",
  "admy.f_img_process_bg": "Immagine — Sfondo Processo",
  "admy.f_img_trust_bg": "Immagine — Sfondo Fiducia",
  "admy.f_img_instagram_1": "Immagine — Instagram 1",
  "admy.f_img_instagram_2": "Immagine — Instagram 2",
  "admy.f_img_instagram_3": "Immagine — Instagram 3",
  "admy.f_img_instagram_4": "Immagine — Instagram 4",

  // ── shared / about ──
  "admy.f_tag": "Etichetta",
  "admy.f_headline_line1": "Titolo Riga 1",
  "admy.f_headline_line2": "Titolo Riga 2",
  "admy.f_description": "Descrizione",
  "admy.f_quote": "Citazione",
  "admy.f_name": "Nome",
  "admy.f_position": "Posizione",
  "admy.f_mission_title": "Missione — Titolo",
  "admy.f_mission_text": "Missione — Testo",
  "admy.f_values_title": "Valori — Titolo",
  "admy.f_values_text": "Valori — Testo",
  "admy.f_why_albania_title": "Perché l'Albania — Titolo",
  "admy.f_why_albania_text": "Perché l'Albania — Testo",
  "admy.f_cta_heading": "CTA — Titolo",
  "admy.f_cta_subtitle": "CTA — Sottotitolo",
  "admy.f_cta_button": "CTA — Pulsante",
  "admy.f_img_hero_bg_tirana": "Immagine — Sfondo Hero (Tirana)",
  "admy.f_img_doctor": "Immagine — Foto Team/Medico",
  "admy.f_img_mission": "Immagine — Missione",
  "admy.f_img_clinic": "Immagine — Clinica",

  // ── services ──
  "admy.f_headline": "Titolo",
  "admy.f_subtitle": "Sottotitolo",
  "admy.f_hair_text": "Trapianto di capelli — Testo",
  "admy.f_hair_price": "Trapianto di capelli — Prezzo",
  "admy.f_dental2_title": "Odontoiatria — Titolo",
  "admy.f_dental2_text": "Odontoiatria — Testo",
  "admy.f_dental2_price": "Odontoiatria — Prezzo",
  "admy.f_botox2_title": "Botox — Titolo",
  "admy.f_botox2_text": "Botox — Testo",
  "admy.f_botox2_price": "Botox — Prezzo",
  "admy.f_surgery_title": "Chirurgia — Titolo",
  "admy.f_surgery_text": "Chirurgia — Testo",
  "admy.f_surgery_price": "Chirurgia — Prezzo",
  "admy.f_cta_text": "Testo CTA",
  "admy.f_cta_subtitle2": "Sottotitolo CTA",
  "admy.f_img_dental2": "Immagine — Odontoiatria",
  "admy.f_img_botox2": "Immagine — Botox",
  "admy.f_img_surgery": "Immagine — Chirurgia",

  // ── pricing ──
  "admy.f_essential_title": "Essential — Titolo",
  "admy.f_essential_price": "Essential — Prezzo",
  "admy.f_essential_desc": "Essential — Descrizione",
  "admy.f_essential_features": "Essential — Caratteristiche (separate da virgole)",
  "admy.f_premium_title": "Premium — Titolo",
  "admy.f_premium_price": "Premium — Prezzo",
  "admy.f_premium_desc": "Premium — Descrizione",
  "admy.f_premium_features": "Premium — Caratteristiche (separate da virgole)",
  "admy.f_luxe_title": "Luxe — Titolo",
  "admy.f_luxe_price": "Luxe — Prezzo",
  "admy.f_luxe_desc": "Luxe — Descrizione",
  "admy.f_luxe_features": "Luxe — Caratteristiche (separate da virgole)",
  "admy.f_exclusif_title": "Exclusif — Titolo",
  "admy.f_exclusif_price": "Exclusif — Prezzo",
  "admy.f_exclusif_desc": "Exclusif — Descrizione",
  "admy.f_exclusif_features": "Exclusif — Caratteristiche (separate da virgole)",
  "admy.f_guarantee_text": "Testo garanzia",
  "admy.f_img_essential": "Immagine — Pacchetto Essential",
  "admy.f_img_premium": "Immagine — Pacchetto Premium",
  "admy.f_img_luxe": "Immagine — Pacchetto Luxe",
  "admy.f_img_exclusif": "Immagine — Pacchetto Exclusif",

  // ── booking ──
  "admy.f_hero_subtitle2": "Sottotitolo Hero",
  "admy.f_form_title": "Modulo — Titolo",
  "admy.f_form_subtitle": "Modulo — Sottotitolo",
  "admy.f_form_firstname": "Modulo — Etichetta Nome",
  "admy.f_form_lastname": "Modulo — Etichetta Cognome",
  "admy.f_form_email": "Modulo — Etichetta E-mail",
  "admy.f_form_phone": "Modulo — Etichetta Telefono",
  "admy.f_form_service": "Modulo — Etichetta Trattamento",
  "admy.f_form_message": "Modulo — Etichetta Messaggio",
  "admy.f_form_privacy": "Modulo — Testo Privacy",
  "admy.f_success_title": "Successo — Titolo",
  "admy.f_success_message": "Successo — Messaggio",
  "admy.f_contact_tag": "Contatto — Etichetta",
  "admy.f_contact_heading": "Contatto — Titolo",
  "admy.f_contact_subtitle": "Contatto — Sottotitolo",

  // ── team ──
  "admy.f_cta_headline": "Titolo CTA",
  "admy.f_cta_subtitle3": "Sottotitolo CTA",
  "admy.f_cta_button2": "Pulsante CTA",
  "admy.f_show_more": "Mostra di più",
  "admy.f_show_less": "Mostra di meno",

  // ── gallery ──
  "admy.f_filter_all": "Filtro — Tutti",
  "admy.f_filter_dental": "Filtro — Odontoiatria",
  "admy.f_filter_surgery": "Filtro — Chirurgia",
  "admy.f_filter_hair": "Filtro — Capelli",
  "admy.f_filter_aesthetic": "Filtro — Estetica",
  "admy.f_before_label": "Etichetta Prima",
  "admy.f_after_label": "Etichetta Dopo",
};

export default admy;
